import clone from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';

import { setValue } from '../../Profile/Accounts_react/AccountsUtils';
import { successAppVariablesRequest } from '../../ConsumerArea/ConsumerAreaActions';
import { updateConsumerAreaGlobalContext } from '../../ConsumerArea/utils/updateConsumerAreaGlobalContext';

export const ITERATOR_PRE_BEGIN = 'b';
export const ITERATOR_POST_END = 'e';

export const JUMP_TYPES = {
  FORWARD: 1,
  BACKWARD: -1,
  UNKNOWN: 0,
  RANDOM_ACCESS: 0,
};

export const JUMP_TYPES_OPPOSITES = {
  [JUMP_TYPES.FORWARD]: JUMP_TYPES.BACKWARD,
  [JUMP_TYPES.BACKWARD]: JUMP_TYPES.FORWARD,
  [JUMP_TYPES.RANDOM_ACCESS]: JUMP_TYPES.RANDOM_ACCESS,
};

export const oppositeDirection = jumpType => JUMP_TYPES_OPPOSITES[jumpType];

export const sibling = (iterator, direction) => iterator[iterator.length - 1] + direction;
export const branch = (node, direction) => {
  if (direction > 0) {
    return 0;
  }
  return Object.keys(node)
    .map(k => +k)
    .reduce((max, current) => {
      if (current > max) {
        return current;
      }
      return max;
    }, 0);
};
export const initialize = (direction, root) => {
  const iterator = [];
  let node = clone(root);
  let k = branch(node, direction);
  while (node[k]) {
    iterator.push(k);
    node = node[k];
    k = branch(node, direction);
  }
  return iterator;
};
export const advance = (direction, root, iteratorArg) => {
  if (iteratorArg === ITERATOR_PRE_BEGIN) {
    if (direction <= 0) {
      return iteratorArg;
    }
    return initialize(1, root);
  }

  if (iteratorArg === ITERATOR_POST_END) {
    if (direction >= 0) {
      return iteratorArg;
    }
    return initialize(-1, root);
  }

  const iterator = clone(iteratorArg);
  let node = {
    ...clone(root),
    parent: null,
  };
  let parent = null;
  for (let i = 0; i < iterator.length; i += 1) {
    parent = node;
    node = node[iterator[i]];
    node.parent = parent;
  }
  while (!node.parent[sibling(iterator, direction)]) {
    iterator.pop();
    node = node.parent;
    if (iterator.length <= 0) {
      // We are at the end
      return direction > 0 ? ITERATOR_POST_END : ITERATOR_PRE_BEGIN;
    }
  }

  node = node.parent[sibling(iterator, direction)];
  iterator[iterator.length - 1] = sibling(iterator, direction);

  let k = branch(node, direction);
  while (node[k]) {
    iterator.push(k);
    node = node[k];
    k = branch(node, direction);
  }
  return iterator;
};
export const isVisible = (whatBranch, iterator) => isEqual(whatBranch, iterator);
export const buildMutation = (fieldPath, value) => setValue({}, fieldPath.split('.'), value);

/**
 * @deprecated Use ConsumerArea/hooks/useBootstrapConsumerArea.ts instead
 * thanks <3
 */
export const reloadConsumerArea = (completedWorkflow, showSpinner, callbackReloading, clientId) => {
  const { ADV } = window;
  ADV.util
    .request({
      uri: 'Consumer/Consumer/GetApplicationVariables',
      data: {
        isPresentationMode: window.ADV.info.isPresentationMode,
        completedWorkflow,
        clientId,
      },
      showSpinner,
    })
    .then(response => {
      if (!response.success) {
        ADV.util.Router.go2('FatalError');
      }
      if (ADV.info.isPresentationMode) {
        callbackReloading.call();
        return;
      }

      ADV.store.dispatch(successAppVariablesRequest(response.payload.viewData));

      const variables = response.payload.viewData.ConsumerAreaContext;

      updateConsumerAreaGlobalContext({
        onboardingWorkflow: variables.ConsumerAccessWorkflow,
        modulesToHide: variables.ModulesToHide,
        optOuts: variables.OptOuts,
        featureFlags: variables.FeatureFlags,
        componentName: variables.ComponentName,
      });

      if (variables.ConsumerAccessWorkflow === -1) {
        ADV.util.showConsumerAreaNav(true);
      } else {
        ADV.util.showConsumerAreaNav(false);
      }

      ADV.consumer.refresh_navigation();

      callbackReloading.call();
    });
};

/**
 * @deprecated Use ConsumerArea/hooks/useBootstrapConsumerArea.ts instead
 * thanks <3
 */
export const reloadAdvizrApplication = (completedWorkflow, showSpinner, callbackReloading) => {
  const { ADV } = window;
  if (ADV.util.env('isConsumerArea')) {
    reloadConsumerArea(
      completedWorkflow,
      showSpinner,
      callbackReloading,
      ADV.util.getCurrentClient(ADV.data).Id,
    );
  } else {
    callbackReloading.call();
  }
};

export const iteratorComparator = (a, b) => {
  if (!Array.isArray(a) || !Array.isArray(b)) {
    throw new Error('Iterators must be arrays');
  }

  const minLen = Math.min(a.length, b.length);
  for (let i = 0; i < minLen; i += 1) {
    if (a[i] > b[i]) {
      return 1;
    }
    if (a[i] < b[i]) {
      return -1;
    }
  }
  if (a.length === b.length) {
    return 0;
  }
  throw Error('Iterators must be leaves of the workflow tree');
};

export const endOfWorkflowsRedirectTo = (routeId, routeParams) =>
  ADV.util.Router.go2(routeId, {
    ...routeParams,
    workflowEnded: true,
  });
